import React from 'react'
const MultiUploadTips = ({ onClick }) => {
    return (
        <div>
            1. 仅支持apk格式 , 3G以内，小于100个。
            <br />
            2. 渠道包名称会根据上传的文件名称自动获取，并且需要注明是32位还是64位包体。
            <span style={{ color: 'red' }}>请规范填写名称，应用名-活动名-cp渠道号-包体位数，</span>例如 “
            京东-双十一活动-1008-32 ”，” 京东-双十一活动-1008-64 “，” 京东-双十一活动-1008-32-64“。
            <br />
            3. 提交后，上传任务将在
            <a href="void:0" onClick={onClick}>
                上传管理中心
            </a>
            进行。
            <br />
            4. 渠道包上传后会进入审核状态，通过审核后将自动上线，可在投放时进行选择。审核时间一般不超过2个小时。
            <br />
            5. 为了避免上传失败，建议使用 chrome 浏览器。
        </div>
    )
}

export default MultiUploadTips
